import React from 'react';

const LoadingIndicator = () => (
  <div className="loading-indicator" role="status" aria-live="polite">
    Loading...
  </div>
);

export default LoadingIndicator;
